import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { SocialStreamApiRequest, SocialStreamConfigs } from './socialStreamApiRequestHelper'

Vue.use(Vuex)

export interface SocialStreamConfigsState {
    dataLoading: boolean,
    socialStreamConfigs: SocialStreamConfigs,
}

const getInitialState = (): SocialStreamConfigsState => ({
  dataLoading: true,
  socialStreamConfigs: {
    configs: [],
  },
})

export default new Vuex.Store({  
  state: getInitialState(),
  mutations: {
    setConfigsList(state: SocialStreamConfigsState, data: SocialStreamConfigs) {
      state.socialStreamConfigs.configs = data.configs
      state.dataLoading = false
    },
  },
  actions: {
    getSocialStreamConfigsData(context: any) {
      const configs = SocialStreamApiRequest.getSocialStreamConfigs()

      return configs
        .then((result: AxiosResponse<SocialStreamConfigs>) => {
          if (result.status !== 200) {
            Notifications.commit('addError', 'socialStream.errorGettingSocialStreamConfigs', { root: true })
            return
          }
          context.commit('setConfigsList', result.data)
        })
        .catch(error => {
          Notifications.commit('addError', error, { root: true })
        })
    },
    
  },
})